var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlanetscale = function SvgPlanetscale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "planetscale_svg__flex-shrink-0 planetscale_svg__block",
    width: 36,
    height: 36,
    viewBox: "0 0 44 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.85 9.85 0 22 0c8.934 0 16.623 5.325 20.069 12.974L12.974 42.069a21.964 21.964 0 0 1-3.547-2.014L27.482 22H22L6.444 37.556A21.931 21.931 0 0 1 0 22ZM44 22.008 22.008 44C34.152 43.996 43.996 34.152 44 22.008Z"
  })));
};
export default SvgPlanetscale;